<template>
  <div v-if="form" class="dashboard-form">
    <div class="md-layout md-alignment-top-left">
      <div class="md-layout-item">
        <div class="form-title">
          {{form.name}}
        </div>
      </div>
      <div class="md-layout-item">
        <md-tabs class="md-xsmall-hide" md-sync-route md-alignment="right">
          <md-tab id="tab-submissions" md-label="Submissions" :to="makeFormUrl('submissions')"></md-tab>
          <md-tab id="tab-setup" md-label="Setup" :to="makeFormUrl('setup')"></md-tab>
          <md-tab id="tab-edit" md-label="Edit" :to="makeFormUrl('edit')"></md-tab>
          <!-- <md-tab id="tab-notifications" md-label="Notifications" :to="makeFormUrl('notifications')"></md-tab> -->
          <md-tab id="tab-export" md-label="Export" :to="makeFormUrl('export')"></md-tab>
        </md-tabs>

        <md-menu class="dropdown-navigation-menu md-xsmall-100" md-size="small" md-align-trigger>
          <md-button md-menu-trigger>
            Navigation
            <i class="dropdown-icon">
              <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path> <path d="M0-.75h24v24H0z" fill="none"></path></svg>
            </i>
          </md-button>

          <md-menu-content>
            <md-menu-item class="tab-menu-navigation-item" :to="makeFormUrl('submissions')">Submissions</md-menu-item>
            <md-menu-item class="tab-menu-navigation-item" :to="makeFormUrl('setup')">Setup</md-menu-item>
            <md-menu-item class="tab-menu-navigation-item" :to="makeFormUrl('edit')">Edit</md-menu-item>
            <!-- <md-menu-item class="tab-menu-navigation-item" :to="makeFormUrl('notifications')">Notifications</md-menu-item> -->
            <md-menu-item class="tab-menu-navigation-item" :to="makeFormUrl('export')">Export</md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'DashboardForm',
  mounted () {
    this.fetchForm()
  },
  data () {
    return {
      expandNavigation: false
    }
  },
  watch: {
    form_id (newValue) {
      this.fetchForm()
    }
  },
  computed: {
    form_id () {
      return this.$route.params.form_id
    },
    form () {
      return this.$store.getters['currentForm']
    }
  },
  methods: {
    async fetchForm () {
      try {
        await this.$store.dispatch('fetchCurrentForm', this.form_id)
      } catch (error) {
        window.log.debug(error)
      }
    },
    makeFormUrl (path) {
      return '/forms/' + this.form_id + '/' + path
    },
    doNothing () {
      // do nothing
    }
  }
}
</script>

<style lang='scss'>
  .dashboard-form {
    text-align: left;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  @media (min-width: 768px) {
    .dashboard-form {
      width: 687px;
    }
  }
  @media (min-width: 992px) {
    .dashboard-form {
      width: 970px;
    }
  }
  @media (min-width: 1200px) {
    .dashboard-form {
      width: 1080px;
    }
  }

  .dashboard-form .md-tabs {
    margin-bottom: 40px;
  }

  .dashboard-form .form-title {
    max-width: 264px;
    min-width: 72px;
    height: 48px;
    line-height: 48px;
    margin: 0;
    border-radius: 0;
    font-size: 16px;
    font-weight: bold;
    vertical-align: middle;
  }

  .dashboard-form .md-menu {
    float: right;
  }

  .dashboard-form .md-menu button {
    max-width: 264px;
    min-width: 72px;
    height: 48px;
    line-height: 48px;
    margin: 0;
    font-size: 13px;
    vertical-align: middle;
  }

  .dashboard-form .dropdown-icon svg {
    vertical-align: middle;
    margin-bottom: 4px;
  }

  .tab-menu-navigation-item .md-list-item-content {
    font-size: 13px;
    min-height: 36px;
  }

  @media screen and (max-width: 600px) {
    .dashboard-form .md-xsmall-hide {
      display: none;
    }
  }
  @media screen and (min-width: 601px) {
    .dashboard-form .dropdown-navigation-menu  {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/DashboardForm.vue